// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SchemaExplorer.module.css */

.SchemaExplorer_explorerToolbar__kCiQC {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 4px 8px 4px;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 4px;
    flex-shrink: 0;
}

.SchemaExplorer_explorerTitle__Us2FW {
    /* 제목이 남는 자리를 차지한다 — 오른쪽에 연결·접기 버튼이 붙어 선다 */
    flex: 1 1 auto;
    min-width: 0;
    font-size: var(--font-size-ui, 12px);
    font-weight: 600;
    color: #555 !important;
    font-family: var(--font-ui, 'Segoe UI', sans-serif);
}

.SchemaExplorer_explorerToolbarBtn__WVT6Z {
    display: flex;
    align-items: center;
    padding: 3px 10px;
    font-size: 11px;
    border: 1px solid #007bff;
    border-radius: 4px;
    background: #fff !important;
    color: #007bff !important;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
}

/* 탐색기 접기 — 연결 버튼과 달리 조용한 아이콘 버튼(창 제목줄의 닫기와 같은 결) */
.SchemaExplorer_explorerCollapseBtn__0i7xM {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    margin-left: 4px;
    padding: 0;
    border: none;
    border-radius: 4px;
    background: transparent;
    color: var(--color-text-muted, #6b7280);
    cursor: pointer;
    transition: background-color 150ms ease, color 150ms ease;
}
.SchemaExplorer_explorerCollapseBtn__0i7xM:hover { background: var(--color-hover, #eceef1); color: var(--color-text, #1f2937); }
@media (prefers-reduced-motion: reduce) { .SchemaExplorer_explorerCollapseBtn__0i7xM { transition: none; } }

.SchemaExplorer_explorerToolbarBtn__WVT6Z:hover {
    background: #007bff !important;
    color: #fff !important;
}

/* react-icons 아이콘에 title prop 을 직접 주면 <svg> 의 title ATTRIBUTE 가 아니라 자식 <title> TAG 로
   렌더링된다 — App.js 의 전역 [title] 스윕(el.hasAttribute('title'))이 못 잡아서 브라우저 네이티브
   툴팁(다크모드 미적용)으로 샜다. title 을 이 span(진짜 DOM title 속성)으로 옮기고 아이콘을 감싼다.
   inline-flex 로 아이콘 크기에 딱 맞게 shrink-wrap — 부모 flex(.connActions 등) 정렬에 영향 없음. */
.SchemaExplorer_iconTipWrap__mXkln {
    display: inline-flex;
    align-items: center;
}

/* Sessions/Schemas 가상 폴더 아이콘 — 라이트 모드 색은 그대로, 다크 모드는 더 차분한 톤으로.
   (개별 스키마 노드 색(#f39c12)은 그대로 둔다 — 피드백은 이 두 폴더 아이콘 한정) */
.SchemaExplorer_sessionsFolderIcon__pY5J4 { color: #3b82f6; }
.SchemaExplorer_schemasFolderIcon__XyOwj { color: #f39c12; }
[data-theme="dark"] .SchemaExplorer_sessionsFolderIcon__pY5J4 { color: var(--color-accent-fg); }
[data-theme="dark"] .SchemaExplorer_schemasFolderIcon__XyOwj { color: #b45309; }

/* react-arborist(react-window) 의 실제 스크롤 컨테이너 — Tree 의 className prop 으로 여기 붙는다.
   하위 스키마를 펼쳐 세로 스크롤이 생기면 스크롤바 폭만큼 콘텐츠 너비가 줄어 오른쪽 아이콘 열이
   좌측으로 밀렸다. 스크롤 유무와 무관하게 항상 그 공간을 미리 확보해 밀림을 없앤다. */
.SchemaExplorer_treeScroll__iyD1I {
    scrollbar-gutter: stable;
}

.SchemaExplorer_schemaExplorerContainer__9clFi {
    padding: 10px;
    /* border-right는 App.css의 .sidebar에서 처리하므로 여기서는 제거 가능 */
    /* overflow-y는 Tree 컴포넌트가 내부적으로 처리할 수 있도록 flex-grow와 함께 사용 */
    flex-grow: 1; /* 부모 flex 컨테이너(.sidebar) 내에서 가능한 많은 공간 차지 */
    display: flex; /* 내부 Tree 컴포넌트가 높이 100%를 올바르게 인식하도록 */
    flex-direction: column;
    min-height: 0; /* flex 아이템이 내용보다 작아질 수 있도록 허용 (중요) */
}

/* 탐색기 검색바 — 트리 노드 이름 필터 */
.SchemaExplorer_explorerSearchBar__gZ424 {
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 0 0 6px 0;
    padding: 4px 6px;
    background: var(--color-bg-secondary, #f5f6f8);
    border: 1px solid var(--color-border, #d1d5db);
    border-radius: 4px;
    flex-shrink: 0;
}
.SchemaExplorer_explorerSearchIcon__ynbyK {
    color: var(--color-text-muted, #9ca3af);
    flex-shrink: 0;
}
.SchemaExplorer_explorerSearchInput__wMCNJ {
    flex: 1 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 12px;
    color: var(--color-text, #1f2937);
    min-width: 0;
}
.SchemaExplorer_explorerSearchInput__wMCNJ::placeholder {
    color: var(--color-text-muted, #9ca3af);
}
.SchemaExplorer_explorerSearchClear__lt8TE {
    background: transparent;
    border: none;
    color: var(--color-text-muted, #9ca3af);
    cursor: pointer;
    padding: 1px 3px;
    border-radius: 3px;
    display: inline-flex;
    align-items: center;
    transition: background-color 150ms ease, color 150ms ease;
}
.SchemaExplorer_explorerSearchClear__lt8TE:hover {
    background: var(--color-hover, rgba(0,0,0,0.06));
    color: var(--color-text, #1f2937);
}
[data-theme="dark"] .SchemaExplorer_explorerSearchBar__gZ424 {
    background: var(--color-bg-tertiary);
    border-color: var(--color-border);
}
[data-theme="dark"] .SchemaExplorer_explorerSearchInput__wMCNJ {
    color: var(--color-text);
}

.SchemaExplorer_node__RrJuJ {
    display: flex;
    align-items: center;
    padding: 1px 0;
    line-height: 1.15;
    cursor: pointer;
    white-space: nowrap; /* 줄바꿈 방지 */
}

.SchemaExplorer_node__RrJuJ:hover {
    background-color: #f0f0f0 !important;
}

.SchemaExplorer_icon__7XisI {
    margin-right: 5px;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
}

.SchemaExplorer_spinning__RfiXW {
    animation: SchemaExplorer_spin__3Ek2i 1s linear infinite;
}

@keyframes SchemaExplorer_spin__3Ek2i {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.SchemaExplorer_nodeName__BLwDT {
    font-weight: 500;
    font-size: var(--font-size-tree, 12px);
    font-family: var(--font-ui, 'Segoe UI', sans-serif);
}

.SchemaExplorer_columnMeta__3nY18 {
    font-size: 0.85em;
    color: #555 !important;
    margin-left: 6px;
}

.SchemaExplorer_loadingText__Pp5n4 {
    margin-left: 8px;
    font-style: italic;
    color: #888 !important;
}

.SchemaExplorer_errorText__YYZPY {
    margin-left: 8px;
    font-style: italic;
    color: red;
}

.SchemaExplorer_node__RrJuJ.SchemaExplorer_selected__iyL3U > span {
    font-weight: bold; /* 선택된 노드 이름 굵게 */
}

/* 아이콘과 텍스트 정렬을 위한 추가 스타일 (필요시) */
.SchemaExplorer_node__RrJuJ span {
    vertical-align: middle;
}

.SchemaExplorer_nodeContent__TdcBy {
    display: flex;
    align-items: center;
    flex: 1 1;
    justify-content: space-between;
}

.SchemaExplorer_erdIcon__cwVMk {
    margin-left: 8px;
    font-size: 0.9em;
    cursor: pointer;
    transition: color 0.2s ease;
}

.SchemaExplorer_erdIcon__cwVMk:hover {
    color: #6c2c8c !important;
    transform: scale(1.1);
} 
/* 다크모드 */
[data-theme="dark"] .SchemaExplorer_schemaExplorerContainer__9clFi { background: var(--color-bg-secondary) !important; }
[data-theme="dark"] .SchemaExplorer_node__RrJuJ:hover { background: var(--color-hover) !important; }
[data-theme="dark"] .SchemaExplorer_explorerToolbar__kCiQC { border-color: var(--color-border) !important; }
[data-theme="dark"] .SchemaExplorer_explorerToolbarBtn__WVT6Z { color: var(--color-accent-fg) !important; border-color: var(--color-accent-fg) !important; background: transparent !important; }
[data-theme="dark"] .SchemaExplorer_explorerToolbarBtn__WVT6Z:hover { background: var(--color-hover) !important; color: var(--color-text) !important; }
[data-theme="dark"] .SchemaExplorer_explorerTitle__Us2FW { color: var(--color-text-secondary) !important; }
[data-theme="dark"] .SchemaExplorer_nodeName__BLwDT { color: var(--color-text) !important; }
[data-theme="dark"] .SchemaExplorer_loadingText__Pp5n4 { color: var(--color-text-muted) !important; }
[data-theme="dark"] .SchemaExplorer_errorText__YYZPY { color: #ef5350 !important; }
[data-theme="dark"] .SchemaExplorer_erdIcon__cwVMk { color: #ce93d8 !important; }
[data-theme="dark"] .SchemaExplorer_erdIcon__cwVMk:hover { color: #e1bee7 !important; }
[data-theme="dark"] .SchemaExplorer_icon__7XisI { color: inherit !important; }

/* 연결 노드 액션 아이콘 */
.SchemaExplorer_connActions__HgkO2 {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
    /* 평소엔 흐릿하게(존재 인지 가능), hover 시 또렷이 표시 — opacity:0 으로 완전 숨김은 발견성 ↓ */
    opacity: 0.55;
    transition: opacity 0.15s;
}
.SchemaExplorer_node__RrJuJ:hover .SchemaExplorer_connActions__HgkO2 {
    opacity: 1;
}
.SchemaExplorer_connActionIcon__3Ngi0 {
    font-size: 11px;
    color: var(--color-text-muted, #999);
    cursor: pointer;
    padding: 2px;
}
.SchemaExplorer_connActionIcon__3Ngi0:hover {
    color: var(--color-accent, #007bff);
}
.SchemaExplorer_connActionIconDanger__7ot37 {
    font-size: 11px;
    color: var(--color-text-muted, #999);
    cursor: pointer;
    padding: 2px;
}
.SchemaExplorer_connActionIconDanger__7ot37:hover {
    color: #e53935;
}

.SchemaExplorer_connActionIconSuccess__\\+Teyy {
    font-size: 11px;
    color: var(--color-text-muted, #999);
    cursor: pointer;
    padding: 2px;
}
.SchemaExplorer_connActionIconSuccess__\\+Teyy:hover {
    color: #43a047;
}
/*
 * 읽기 전용 배지 — 눌러 보고 실패하기 전에 알아야 한다. 끊김 배지와 **다른 색**이다:
 * 끊김은 고칠 수 있는 상태이고, 이쪽은 권한이라 사용자가 어쩔 수 없다.
 */
.SchemaExplorer_readOnlyBadge__TEorQ {
    font-size: 9px;
    color: #9a6b17;
    background: rgba(224, 180, 106, 0.2);
    border: 1px solid #e0b46a;
    padding: 0 5px;
    border-radius: 3px;
    margin-left: 4px;
    display: inline-flex;
    align-items: center;
    line-height: 1.5;
    white-space: nowrap;
}
[data-theme="dark"] .SchemaExplorer_readOnlyBadge__TEorQ { color: #e0be82; border-color: #55502f; }

.SchemaExplorer_disconnectedBadge__eCRms {
    font-size: 9px;
    color: var(--color-text-muted, #999);
    background: var(--color-bg-tertiary, #eee);
    padding: 1px 5px;
    border-radius: 3px;
    margin-left: 4px;
    display: inline-flex;
    align-items: center;
    line-height: 1;
}

/* ============================================================ */
/* Phase 2 — 세션 트리 노드                                      */
/* ============================================================ */
.SchemaExplorer_sessionNode__5YUfa {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    min-width: 0;
}
.SchemaExplorer_sessionLabel__railN {
    flex: 1 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
}
.SchemaExplorer_sessionStatusDot__0q7qt {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    /* 색 전환은 부드럽게 — UI Conventions */
    transition: background-color 160ms ease, box-shadow 160ms ease;
}
.SchemaExplorer_sessionStatusDotIdle__CN96g {
    background: #9ca3af;
}
.SchemaExplorer_sessionStatusDotRunning__BBNye {
    background: #10b981;
    box-shadow: 0 0 4px rgba(16, 185, 129, 0.5);
}
.SchemaExplorer_sessionStatusDotCancelling__cioAM {
    background: #f59e0b;
    animation: SchemaExplorer_sessionPulse__BLjzY 1s infinite;
}
.SchemaExplorer_sessionElapsed__LeWV7 {
    font-size: 11px;
    color: var(--color-text-muted, #6b7280);
    font-variant-numeric: tabular-nums;
    flex-shrink: 0;
}
.SchemaExplorer_sessionSid__tJHSr {
    font-size: 10px;
    color: var(--color-text-muted, #9ca3af);
    flex-shrink: 0;
}
.SchemaExplorer_sessionCancelling__FcRt8 {
    font-size: 11px;
    color: #f59e0b;
    font-style: italic;
    flex-shrink: 0;
}
.SchemaExplorer_sessionsFolderCount__Sthx2 {
    font-size: 11px;
    color: var(--color-text-muted, #6b7280);
    margin-left: 4px;
}
/* Sessions 폴더 라벨 옆 + 아이콘 — 클릭하면 새 세션 생성 (이전엔 별도 add-session 노드였음). */
.SchemaExplorer_sessionsFolderAddIcon__O9NRM {
    font-size: 14px;
    padding: 2px;
    border-radius: 3px;
    transition: background-color 150ms ease, color 150ms ease;
}
.SchemaExplorer_sessionsFolderAddIcon__O9NRM:hover {
    background-color: rgba(59, 130, 246, 0.12);
    color: #1d4ed8;
}
.SchemaExplorer_connActionIconDisabled__J1uMK {
    font-size: 11px;
    color: var(--color-text-muted, #d1d5db);
    cursor: not-allowed;
    padding: 2px;
    opacity: 0.5;
}

@keyframes SchemaExplorer_sessionPulse__BLjzY {
    50% { opacity: 0.4; }
}
@media (prefers-reduced-motion: reduce) {
    .SchemaExplorer_sessionStatusDotCancelling__cioAM { animation: none; }
    .SchemaExplorer_sessionStatusDot__0q7qt,
    .SchemaExplorer_sessionsFolderAddIcon__O9NRM { transition: none; }
}

/* 연결이 하나도 없을 때의 빈 상태 안내 */
.SchemaExplorer_explorerEmptyState__54A6P {
    padding: 18px 14px;
    text-align: center;
    color: #6b7280;
    font-size: 12px;
    line-height: 1.6;
    animation: SchemaExplorer_explorer-empty-fade__rGfpT 160ms ease-out;
}

.SchemaExplorer_explorerEmptyState__54A6P p {
    margin: 0 0 10px 0;
}

.SchemaExplorer_explorerEmptyState__54A6P button {
    padding: 5px 12px;
    font-size: 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: transparent;
    color: inherit;
    cursor: pointer;
    transition: background-color 150ms ease, border-color 150ms ease;
}

.SchemaExplorer_explorerEmptyState__54A6P button:hover {
    background: rgba(59, 130, 246, 0.1);
    border-color: #3b82f6;
}

.SchemaExplorer_explorerEmptyState__54A6P span {
    display: block;
    margin-top: 10px;
    font-size: 11px;
    opacity: 0.75;
}

@keyframes SchemaExplorer_explorer-empty-fade__rGfpT {
    from { opacity: 0; transform: translateY(-3px); }
    to   { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
    .SchemaExplorer_explorerEmptyState__54A6P { animation: none; }
    .SchemaExplorer_explorerEmptyState__54A6P button { transition: none; }
}

[data-theme="dark"] .SchemaExplorer_explorerEmptyState__54A6P {
    color: var(--color-text-muted);
}

[data-theme="dark"] .SchemaExplorer_explorerEmptyState__54A6P button {
    border-color: var(--color-border);
}

/* 다크 모드 */
[data-theme="dark"] .SchemaExplorer_sessionElapsed__LeWV7,
[data-theme="dark"] .SchemaExplorer_sessionSid__tJHSr,
[data-theme="dark"] .SchemaExplorer_sessionsFolderCount__Sthx2 {
    color: var(--color-text-muted);
}
[data-theme="dark"] .SchemaExplorer_sessionsFolderAddIcon__O9NRM {
    color: #6cb6ff !important;
}
[data-theme="dark"] .SchemaExplorer_sessionsFolderAddIcon__O9NRM:hover {
    background-color: var(--color-hover);
    color: var(--color-text) !important;
}
[data-theme="dark"] .SchemaExplorer_sessionStatusDotIdle__CN96g {
    background: #6b7280;
}

/* 즐겨찾기로 다시 켜질 때 즉시 튀어나오지 않게 */
.SchemaExplorer_explorerToolbarBtn__WVT6Z { animation: SchemaExplorer_exp-fav-in__sF0y3 160ms ease-out; }
@keyframes SchemaExplorer_exp-fav-in__sF0y3 {
    from { opacity: 0; transform: translateY(-3px); }
    to   { opacity: 1; transform: translateY(0); }
}
@media (prefers-reduced-motion: reduce) {
    .SchemaExplorer_explorerToolbarBtn__WVT6Z { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/SchemaExplorer.module.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wBAAwB;IACxB,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,2CAA2C;IAC3C,cAAc;IACd,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;IAChB,sBAAsB;IACtB,mDAAmD;AACvD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;IACzB,eAAe;IACf,yCAAyC;AAC7C;;AAEA,mDAAmD;AACnD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,uCAAuC;IACvC,eAAe;IACf,yDAAyD;AAC7D;AACA,mDAA6B,uCAAuC,EAAE,iCAAiC,EAAE;AACzG,0CAA0C,6CAAuB,gBAAgB,EAAE,EAAE;;AAErF;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;;;gFAGgF;AAChF;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;wDACwD;AACxD,4CAAsB,cAAc,EAAE;AACtC,2CAAqB,cAAc,EAAE;AACrC,gEAAmD,6BAA6B,EAAE;AAClF,+DAAkD,cAAc,EAAE;;AAElE;;oDAEoD;AACpD;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,uDAAuD;IACvD,4DAA4D;IAC5D,YAAY,EAAE,4CAA4C;IAC1D,aAAa,EAAE,sCAAsC;IACrD,sBAAsB;IACtB,aAAa,EAAE,qCAAqC;AACxD;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,8CAA8C;IAC9C,8CAA8C;IAC9C,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,uCAAuC;IACvC,cAAc;AAClB;AACA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,yDAAyD;AAC7D;AACA;IACI,gDAAgD;IAChD,iCAAiC;AACrC;AACA;IACI,oCAAoC;IACpC,iCAAiC;AACrC;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,mBAAmB,EAAE,WAAW;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,wDAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,mDAAmD;AACvD;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB,EAAE,iBAAiB;AACxC;;AAEA,iCAAiC;AACjC;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;IACP,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA,SAAS;AACT,qEAAwD,gDAAgD,EAAE;AAC1G,wDAA2C,yCAAyC,EAAE;AACtF,6DAAgD,4CAA4C,EAAE;AAC9F,gEAAmD,wCAAwC,EAAE,+CAA+C,EAAE,kCAAkC,EAAE;AAClL,sEAAyD,yCAAyC,EAAE,mCAAmC,EAAE;AACzI,2DAA8C,6CAA6C,EAAE;AAC7F,sDAAyC,mCAAmC,EAAE;AAC9E,yDAA4C,yCAAyC,EAAE;AACvF,uDAA0C,yBAAyB,EAAE;AACrE,qDAAwC,yBAAyB,EAAE;AACnE,2DAA8C,yBAAyB,EAAE;AACzE,kDAAqC,yBAAyB,EAAE;;AAEhE,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mEAAmE;IACnE,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;IACf,oCAAoC;IACpC,eAAe;IACf,YAAY;AAChB;AACA;IACI,mCAAmC;AACvC;AACA;IACI,eAAe;IACf,oCAAoC;IACpC,eAAe;IACf,YAAY;AAChB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,eAAe;IACf,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;;;EAGE;AACF;IACI,cAAc;IACd,cAAc;IACd,oCAAoC;IACpC,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;AACA,2DAA8C,cAAc,EAAE,qBAAqB,EAAE;;AAErF;IACI,cAAc;IACd,oCAAoC;IACpC,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,iEAAiE;AACjE,4DAA4D;AAC5D,iEAAiE;AACjE;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;AACA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,8DAA8D;AAClE;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,2CAA2C;AAC/C;AACA;IACI,mBAAmB;IACnB,yDAAmC;AACvC;AACA;IACI,eAAe;IACf,uCAAuC;IACvC,kCAAkC;IAClC,cAAc;AAClB;AACA;IACI,eAAe;IACf,uCAAuC;IACvC,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,eAAe;IACf,uCAAuC;IACvC,gBAAgB;AACpB;AACA,qEAAqE;AACrE;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yDAAyD;AAC7D;AACA;IACI,0CAA0C;IAC1C,cAAc;AAClB;AACA;IACI,eAAe;IACf,uCAAuC;IACvC,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,MAAM,YAAY,EAAE;AACxB;AACA;IACI,oDAA8B,eAAe,EAAE;IAC/C;mDACyB,gBAAgB,EAAE;AAC/C;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mEAA6C;AACjD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gEAAgE;AACpE;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AACjD;;AAEA;IACI,4CAAsB,eAAe,EAAE;IACvC,mDAA6B,gBAAgB,EAAE;AACnD;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;AACrC;;AAEA,UAAU;AACV;;;IAGI,8BAA8B;AAClC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B,4CAAsB,0DAAoC,EAAE;AAC5D;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AACjD;AACA;IACI,4CAAsB,eAAe,EAAE;AAC3C","sourcesContent":["/* SchemaExplorer.module.css */\r\n\r\n.explorerToolbar {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 6px 4px 8px 4px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    margin-bottom: 4px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.explorerTitle {\r\n    /* 제목이 남는 자리를 차지한다 — 오른쪽에 연결·접기 버튼이 붙어 선다 */\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n    font-size: var(--font-size-ui, 12px);\r\n    font-weight: 600;\r\n    color: #555 !important;\r\n    font-family: var(--font-ui, 'Segoe UI', sans-serif);\r\n}\r\n\r\n.explorerToolbarBtn {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 3px 10px;\r\n    font-size: 11px;\r\n    border: 1px solid #007bff;\r\n    border-radius: 4px;\r\n    background: #fff !important;\r\n    color: #007bff !important;\r\n    cursor: pointer;\r\n    transition: background 0.15s, color 0.15s;\r\n}\r\n\r\n/* 탐색기 접기 — 연결 버튼과 달리 조용한 아이콘 버튼(창 제목줄의 닫기와 같은 결) */\r\n.explorerCollapseBtn {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 22px;\r\n    height: 22px;\r\n    margin-left: 4px;\r\n    padding: 0;\r\n    border: none;\r\n    border-radius: 4px;\r\n    background: transparent;\r\n    color: var(--color-text-muted, #6b7280);\r\n    cursor: pointer;\r\n    transition: background-color 150ms ease, color 150ms ease;\r\n}\r\n.explorerCollapseBtn:hover { background: var(--color-hover, #eceef1); color: var(--color-text, #1f2937); }\r\n@media (prefers-reduced-motion: reduce) { .explorerCollapseBtn { transition: none; } }\r\n\r\n.explorerToolbarBtn:hover {\r\n    background: #007bff !important;\r\n    color: #fff !important;\r\n}\r\n\r\n/* react-icons 아이콘에 title prop 을 직접 주면 <svg> 의 title ATTRIBUTE 가 아니라 자식 <title> TAG 로\r\n   렌더링된다 — App.js 의 전역 [title] 스윕(el.hasAttribute('title'))이 못 잡아서 브라우저 네이티브\r\n   툴팁(다크모드 미적용)으로 샜다. title 을 이 span(진짜 DOM title 속성)으로 옮기고 아이콘을 감싼다.\r\n   inline-flex 로 아이콘 크기에 딱 맞게 shrink-wrap — 부모 flex(.connActions 등) 정렬에 영향 없음. */\r\n.iconTipWrap {\r\n    display: inline-flex;\r\n    align-items: center;\r\n}\r\n\r\n/* Sessions/Schemas 가상 폴더 아이콘 — 라이트 모드 색은 그대로, 다크 모드는 더 차분한 톤으로.\r\n   (개별 스키마 노드 색(#f39c12)은 그대로 둔다 — 피드백은 이 두 폴더 아이콘 한정) */\r\n.sessionsFolderIcon { color: #3b82f6; }\r\n.schemasFolderIcon { color: #f39c12; }\r\n:global([data-theme=\"dark\"]) .sessionsFolderIcon { color: var(--color-accent-fg); }\r\n:global([data-theme=\"dark\"]) .schemasFolderIcon { color: #b45309; }\r\n\r\n/* react-arborist(react-window) 의 실제 스크롤 컨테이너 — Tree 의 className prop 으로 여기 붙는다.\r\n   하위 스키마를 펼쳐 세로 스크롤이 생기면 스크롤바 폭만큼 콘텐츠 너비가 줄어 오른쪽 아이콘 열이\r\n   좌측으로 밀렸다. 스크롤 유무와 무관하게 항상 그 공간을 미리 확보해 밀림을 없앤다. */\r\n.treeScroll {\r\n    scrollbar-gutter: stable;\r\n}\r\n\r\n.schemaExplorerContainer {\r\n    padding: 10px;\r\n    /* border-right는 App.css의 .sidebar에서 처리하므로 여기서는 제거 가능 */\r\n    /* overflow-y는 Tree 컴포넌트가 내부적으로 처리할 수 있도록 flex-grow와 함께 사용 */\r\n    flex-grow: 1; /* 부모 flex 컨테이너(.sidebar) 내에서 가능한 많은 공간 차지 */\r\n    display: flex; /* 내부 Tree 컴포넌트가 높이 100%를 올바르게 인식하도록 */\r\n    flex-direction: column;\r\n    min-height: 0; /* flex 아이템이 내용보다 작아질 수 있도록 허용 (중요) */\r\n}\r\n\r\n/* 탐색기 검색바 — 트리 노드 이름 필터 */\r\n.explorerSearchBar {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    margin: 0 0 6px 0;\r\n    padding: 4px 6px;\r\n    background: var(--color-bg-secondary, #f5f6f8);\r\n    border: 1px solid var(--color-border, #d1d5db);\r\n    border-radius: 4px;\r\n    flex-shrink: 0;\r\n}\r\n.explorerSearchIcon {\r\n    color: var(--color-text-muted, #9ca3af);\r\n    flex-shrink: 0;\r\n}\r\n.explorerSearchInput {\r\n    flex: 1;\r\n    border: none;\r\n    outline: none;\r\n    background: transparent;\r\n    font-size: 12px;\r\n    color: var(--color-text, #1f2937);\r\n    min-width: 0;\r\n}\r\n.explorerSearchInput::placeholder {\r\n    color: var(--color-text-muted, #9ca3af);\r\n}\r\n.explorerSearchClear {\r\n    background: transparent;\r\n    border: none;\r\n    color: var(--color-text-muted, #9ca3af);\r\n    cursor: pointer;\r\n    padding: 1px 3px;\r\n    border-radius: 3px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    transition: background-color 150ms ease, color 150ms ease;\r\n}\r\n.explorerSearchClear:hover {\r\n    background: var(--color-hover, rgba(0,0,0,0.06));\r\n    color: var(--color-text, #1f2937);\r\n}\r\n:global([data-theme=\"dark\"]) .explorerSearchBar {\r\n    background: var(--color-bg-tertiary);\r\n    border-color: var(--color-border);\r\n}\r\n:global([data-theme=\"dark\"]) .explorerSearchInput {\r\n    color: var(--color-text);\r\n}\r\n\r\n.node {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 1px 0;\r\n    line-height: 1.15;\r\n    cursor: pointer;\r\n    white-space: nowrap; /* 줄바꿈 방지 */\r\n}\r\n\r\n.node:hover {\r\n    background-color: #f0f0f0 !important;\r\n}\r\n\r\n.icon {\r\n    margin-right: 5px;\r\n    font-size: 12px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.spinning {\r\n    animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n.nodeName {\r\n    font-weight: 500;\r\n    font-size: var(--font-size-tree, 12px);\r\n    font-family: var(--font-ui, 'Segoe UI', sans-serif);\r\n}\r\n\r\n.columnMeta {\r\n    font-size: 0.85em;\r\n    color: #555 !important;\r\n    margin-left: 6px;\r\n}\r\n\r\n.loadingText {\r\n    margin-left: 8px;\r\n    font-style: italic;\r\n    color: #888 !important;\r\n}\r\n\r\n.errorText {\r\n    margin-left: 8px;\r\n    font-style: italic;\r\n    color: red;\r\n}\r\n\r\n.node.selected > span {\r\n    font-weight: bold; /* 선택된 노드 이름 굵게 */\r\n}\r\n\r\n/* 아이콘과 텍스트 정렬을 위한 추가 스타일 (필요시) */\r\n.node span {\r\n    vertical-align: middle;\r\n}\r\n\r\n.nodeContent {\r\n    display: flex;\r\n    align-items: center;\r\n    flex: 1;\r\n    justify-content: space-between;\r\n}\r\n\r\n.erdIcon {\r\n    margin-left: 8px;\r\n    font-size: 0.9em;\r\n    cursor: pointer;\r\n    transition: color 0.2s ease;\r\n}\r\n\r\n.erdIcon:hover {\r\n    color: #6c2c8c !important;\r\n    transform: scale(1.1);\r\n} \r\n/* 다크모드 */\r\n:global([data-theme=\"dark\"]) .schemaExplorerContainer { background: var(--color-bg-secondary) !important; }\r\n:global([data-theme=\"dark\"]) .node:hover { background: var(--color-hover) !important; }\r\n:global([data-theme=\"dark\"]) .explorerToolbar { border-color: var(--color-border) !important; }\r\n:global([data-theme=\"dark\"]) .explorerToolbarBtn { color: var(--color-accent-fg) !important; border-color: var(--color-accent-fg) !important; background: transparent !important; }\r\n:global([data-theme=\"dark\"]) .explorerToolbarBtn:hover { background: var(--color-hover) !important; color: var(--color-text) !important; }\r\n:global([data-theme=\"dark\"]) .explorerTitle { color: var(--color-text-secondary) !important; }\r\n:global([data-theme=\"dark\"]) .nodeName { color: var(--color-text) !important; }\r\n:global([data-theme=\"dark\"]) .loadingText { color: var(--color-text-muted) !important; }\r\n:global([data-theme=\"dark\"]) .errorText { color: #ef5350 !important; }\r\n:global([data-theme=\"dark\"]) .erdIcon { color: #ce93d8 !important; }\r\n:global([data-theme=\"dark\"]) .erdIcon:hover { color: #e1bee7 !important; }\r\n:global([data-theme=\"dark\"]) .icon { color: inherit !important; }\r\n\r\n/* 연결 노드 액션 아이콘 */\r\n.connActions {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    margin-left: auto;\r\n    /* 평소엔 흐릿하게(존재 인지 가능), hover 시 또렷이 표시 — opacity:0 으로 완전 숨김은 발견성 ↓ */\r\n    opacity: 0.55;\r\n    transition: opacity 0.15s;\r\n}\r\n.node:hover .connActions {\r\n    opacity: 1;\r\n}\r\n.connActionIcon {\r\n    font-size: 11px;\r\n    color: var(--color-text-muted, #999);\r\n    cursor: pointer;\r\n    padding: 2px;\r\n}\r\n.connActionIcon:hover {\r\n    color: var(--color-accent, #007bff);\r\n}\r\n.connActionIconDanger {\r\n    font-size: 11px;\r\n    color: var(--color-text-muted, #999);\r\n    cursor: pointer;\r\n    padding: 2px;\r\n}\r\n.connActionIconDanger:hover {\r\n    color: #e53935;\r\n}\r\n\r\n.connActionIconSuccess {\r\n    font-size: 11px;\r\n    color: var(--color-text-muted, #999);\r\n    cursor: pointer;\r\n    padding: 2px;\r\n}\r\n.connActionIconSuccess:hover {\r\n    color: #43a047;\r\n}\r\n/*\r\n * 읽기 전용 배지 — 눌러 보고 실패하기 전에 알아야 한다. 끊김 배지와 **다른 색**이다:\r\n * 끊김은 고칠 수 있는 상태이고, 이쪽은 권한이라 사용자가 어쩔 수 없다.\r\n */\r\n.readOnlyBadge {\r\n    font-size: 9px;\r\n    color: #9a6b17;\r\n    background: rgba(224, 180, 106, 0.2);\r\n    border: 1px solid #e0b46a;\r\n    padding: 0 5px;\r\n    border-radius: 3px;\r\n    margin-left: 4px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    line-height: 1.5;\r\n    white-space: nowrap;\r\n}\r\n:global([data-theme=\"dark\"]) .readOnlyBadge { color: #e0be82; border-color: #55502f; }\r\n\r\n.disconnectedBadge {\r\n    font-size: 9px;\r\n    color: var(--color-text-muted, #999);\r\n    background: var(--color-bg-tertiary, #eee);\r\n    padding: 1px 5px;\r\n    border-radius: 3px;\r\n    margin-left: 4px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    line-height: 1;\r\n}\r\n\r\n/* ============================================================ */\r\n/* Phase 2 — 세션 트리 노드                                      */\r\n/* ============================================================ */\r\n.sessionNode {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    width: 100%;\r\n    min-width: 0;\r\n}\r\n.sessionLabel {\r\n    flex: 1;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    font-size: 12px;\r\n}\r\n.sessionStatusDot {\r\n    width: 8px;\r\n    height: 8px;\r\n    border-radius: 50%;\r\n    flex-shrink: 0;\r\n    /* 색 전환은 부드럽게 — UI Conventions */\r\n    transition: background-color 160ms ease, box-shadow 160ms ease;\r\n}\r\n.sessionStatusDotIdle {\r\n    background: #9ca3af;\r\n}\r\n.sessionStatusDotRunning {\r\n    background: #10b981;\r\n    box-shadow: 0 0 4px rgba(16, 185, 129, 0.5);\r\n}\r\n.sessionStatusDotCancelling {\r\n    background: #f59e0b;\r\n    animation: sessionPulse 1s infinite;\r\n}\r\n.sessionElapsed {\r\n    font-size: 11px;\r\n    color: var(--color-text-muted, #6b7280);\r\n    font-variant-numeric: tabular-nums;\r\n    flex-shrink: 0;\r\n}\r\n.sessionSid {\r\n    font-size: 10px;\r\n    color: var(--color-text-muted, #9ca3af);\r\n    flex-shrink: 0;\r\n}\r\n.sessionCancelling {\r\n    font-size: 11px;\r\n    color: #f59e0b;\r\n    font-style: italic;\r\n    flex-shrink: 0;\r\n}\r\n.sessionsFolderCount {\r\n    font-size: 11px;\r\n    color: var(--color-text-muted, #6b7280);\r\n    margin-left: 4px;\r\n}\r\n/* Sessions 폴더 라벨 옆 + 아이콘 — 클릭하면 새 세션 생성 (이전엔 별도 add-session 노드였음). */\r\n.sessionsFolderAddIcon {\r\n    font-size: 14px;\r\n    padding: 2px;\r\n    border-radius: 3px;\r\n    transition: background-color 150ms ease, color 150ms ease;\r\n}\r\n.sessionsFolderAddIcon:hover {\r\n    background-color: rgba(59, 130, 246, 0.12);\r\n    color: #1d4ed8;\r\n}\r\n.connActionIconDisabled {\r\n    font-size: 11px;\r\n    color: var(--color-text-muted, #d1d5db);\r\n    cursor: not-allowed;\r\n    padding: 2px;\r\n    opacity: 0.5;\r\n}\r\n\r\n@keyframes sessionPulse {\r\n    50% { opacity: 0.4; }\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n    .sessionStatusDotCancelling { animation: none; }\r\n    .sessionStatusDot,\r\n    .sessionsFolderAddIcon { transition: none; }\r\n}\r\n\r\n/* 연결이 하나도 없을 때의 빈 상태 안내 */\r\n.explorerEmptyState {\r\n    padding: 18px 14px;\r\n    text-align: center;\r\n    color: #6b7280;\r\n    font-size: 12px;\r\n    line-height: 1.6;\r\n    animation: explorer-empty-fade 160ms ease-out;\r\n}\r\n\r\n.explorerEmptyState p {\r\n    margin: 0 0 10px 0;\r\n}\r\n\r\n.explorerEmptyState button {\r\n    padding: 5px 12px;\r\n    font-size: 12px;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n    background: transparent;\r\n    color: inherit;\r\n    cursor: pointer;\r\n    transition: background-color 150ms ease, border-color 150ms ease;\r\n}\r\n\r\n.explorerEmptyState button:hover {\r\n    background: rgba(59, 130, 246, 0.1);\r\n    border-color: #3b82f6;\r\n}\r\n\r\n.explorerEmptyState span {\r\n    display: block;\r\n    margin-top: 10px;\r\n    font-size: 11px;\r\n    opacity: 0.75;\r\n}\r\n\r\n@keyframes explorer-empty-fade {\r\n    from { opacity: 0; transform: translateY(-3px); }\r\n    to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n    .explorerEmptyState { animation: none; }\r\n    .explorerEmptyState button { transition: none; }\r\n}\r\n\r\n[data-theme=\"dark\"] .explorerEmptyState {\r\n    color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .explorerEmptyState button {\r\n    border-color: var(--color-border);\r\n}\r\n\r\n/* 다크 모드 */\r\n[data-theme=\"dark\"] .sessionElapsed,\r\n[data-theme=\"dark\"] .sessionSid,\r\n[data-theme=\"dark\"] .sessionsFolderCount {\r\n    color: var(--color-text-muted);\r\n}\r\n[data-theme=\"dark\"] .sessionsFolderAddIcon {\r\n    color: #6cb6ff !important;\r\n}\r\n[data-theme=\"dark\"] .sessionsFolderAddIcon:hover {\r\n    background-color: var(--color-hover);\r\n    color: var(--color-text) !important;\r\n}\r\n[data-theme=\"dark\"] .sessionStatusDotIdle {\r\n    background: #6b7280;\r\n}\r\n\r\n/* 즐겨찾기로 다시 켜질 때 즉시 튀어나오지 않게 */\r\n.explorerToolbarBtn { animation: exp-fav-in 160ms ease-out; }\r\n@keyframes exp-fav-in {\r\n    from { opacity: 0; transform: translateY(-3px); }\r\n    to   { opacity: 1; transform: translateY(0); }\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n    .explorerToolbarBtn { animation: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"explorerToolbar": `SchemaExplorer_explorerToolbar__kCiQC`,
	"explorerTitle": `SchemaExplorer_explorerTitle__Us2FW`,
	"explorerToolbarBtn": `SchemaExplorer_explorerToolbarBtn__WVT6Z`,
	"explorerCollapseBtn": `SchemaExplorer_explorerCollapseBtn__0i7xM`,
	"iconTipWrap": `SchemaExplorer_iconTipWrap__mXkln`,
	"sessionsFolderIcon": `SchemaExplorer_sessionsFolderIcon__pY5J4`,
	"schemasFolderIcon": `SchemaExplorer_schemasFolderIcon__XyOwj`,
	"treeScroll": `SchemaExplorer_treeScroll__iyD1I`,
	"schemaExplorerContainer": `SchemaExplorer_schemaExplorerContainer__9clFi`,
	"explorerSearchBar": `SchemaExplorer_explorerSearchBar__gZ424`,
	"explorerSearchIcon": `SchemaExplorer_explorerSearchIcon__ynbyK`,
	"explorerSearchInput": `SchemaExplorer_explorerSearchInput__wMCNJ`,
	"explorerSearchClear": `SchemaExplorer_explorerSearchClear__lt8TE`,
	"node": `SchemaExplorer_node__RrJuJ`,
	"icon": `SchemaExplorer_icon__7XisI`,
	"spinning": `SchemaExplorer_spinning__RfiXW`,
	"spin": `SchemaExplorer_spin__3Ek2i`,
	"nodeName": `SchemaExplorer_nodeName__BLwDT`,
	"columnMeta": `SchemaExplorer_columnMeta__3nY18`,
	"loadingText": `SchemaExplorer_loadingText__Pp5n4`,
	"errorText": `SchemaExplorer_errorText__YYZPY`,
	"selected": `SchemaExplorer_selected__iyL3U`,
	"nodeContent": `SchemaExplorer_nodeContent__TdcBy`,
	"erdIcon": `SchemaExplorer_erdIcon__cwVMk`,
	"connActions": `SchemaExplorer_connActions__HgkO2`,
	"connActionIcon": `SchemaExplorer_connActionIcon__3Ngi0`,
	"connActionIconDanger": `SchemaExplorer_connActionIconDanger__7ot37`,
	"connActionIconSuccess": `SchemaExplorer_connActionIconSuccess__+Teyy`,
	"readOnlyBadge": `SchemaExplorer_readOnlyBadge__TEorQ`,
	"disconnectedBadge": `SchemaExplorer_disconnectedBadge__eCRms`,
	"sessionNode": `SchemaExplorer_sessionNode__5YUfa`,
	"sessionLabel": `SchemaExplorer_sessionLabel__railN`,
	"sessionStatusDot": `SchemaExplorer_sessionStatusDot__0q7qt`,
	"sessionStatusDotIdle": `SchemaExplorer_sessionStatusDotIdle__CN96g`,
	"sessionStatusDotRunning": `SchemaExplorer_sessionStatusDotRunning__BBNye`,
	"sessionStatusDotCancelling": `SchemaExplorer_sessionStatusDotCancelling__cioAM`,
	"sessionPulse": `SchemaExplorer_sessionPulse__BLjzY`,
	"sessionElapsed": `SchemaExplorer_sessionElapsed__LeWV7`,
	"sessionSid": `SchemaExplorer_sessionSid__tJHSr`,
	"sessionCancelling": `SchemaExplorer_sessionCancelling__FcRt8`,
	"sessionsFolderCount": `SchemaExplorer_sessionsFolderCount__Sthx2`,
	"sessionsFolderAddIcon": `SchemaExplorer_sessionsFolderAddIcon__O9NRM`,
	"connActionIconDisabled": `SchemaExplorer_connActionIconDisabled__J1uMK`,
	"explorerEmptyState": `SchemaExplorer_explorerEmptyState__54A6P`,
	"explorer-empty-fade": `SchemaExplorer_explorer-empty-fade__rGfpT`,
	"exp-fav-in": `SchemaExplorer_exp-fav-in__sF0y3`
};
export default ___CSS_LOADER_EXPORT___;
